import { render, staticRenderFns } from "./BacktestView.vue?vue&type=template&id=aa04ff9e&scoped=true"
import script from "./BacktestView.vue?vue&type=script&lang=js"
export * from "./BacktestView.vue?vue&type=script&lang=js"
import style0 from "./BacktestView.vue?vue&type=style&index=0&id=aa04ff9e&prod&scoped=true&lang=css"
import style1 from "./BacktestView.vue?vue&type=style&index=1&id=aa04ff9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa04ff9e",
  null
  
)

export default component.exports